/*
 * assets/kcc.js
 * Port of src/components/kona-crown/useScrollReveal.ts (BUILD-SPEC file map).
 *
 * globals.css sets `.scroll-reveal { opacity: 0 }` and only lifts it once the
 * element also carries `.revealed`. In the Next.js build that class was added by
 * an IntersectionObserver in useScrollReveal; this is the same observer, applied
 * to every `.scroll-reveal` (and any `.stagger-children` that has not been
 * pre-revealed in the markup) on the page.
 *
 * Threshold 0.15 and the unobserve-after-first-hit are both lifted from the hook.
 */
(function () {
  'use strict';

  var THRESHOLD = 0.15;
  var SELECTOR = '.scroll-reveal:not(.revealed), .stagger-children:not(.revealed)';

  function revealAll(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('revealed');
  }

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // No IntersectionObserver (or motion is unwelcome): show everything immediately
  // rather than leaving opacity:0 content stranded.
  if (!('IntersectionObserver' in window) || prefersReducedMotion) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        revealAll(document);
      });
    } else {
      revealAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      revealAll(event.target);
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      });
    },
    { threshold: THRESHOLD }
  );

  function observe(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Already on screen at load (hero-adjacent sections): reveal without waiting
      // for a scroll event that may never come on a short page.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('revealed');
      } else {
        observer.observe(el);
      }
    }
  }

  function init() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders a section's DOM; re-scan the new subtree.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
